import trigger_vue_vue_type_script_setup_true_lang_default from "./trigger.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/popper/src/trigger.vue
var trigger_default = trigger_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { trigger_default as default };
//# sourceMappingURL=trigger2.mjs.map